import React from 'react';
import { Icon } from '../../../Icon';
import './FormFailedIconMessage.scss';
export const FormFailedIconMessage = ({ isActive = false, message, }) => {
    if (!isActive)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "form-failed-icon-message" },
        React.createElement("div", { className: "form-failed-icon-message__icon" },
            React.createElement(Icon, { source: "InputAttention" })),
        React.createElement("p", { className: "form-failed-icon-message__message" }, message)));
};
//# sourceMappingURL=FormFailedIconMessage.js.map